export const TILE_SIZE_PX = {
  small: '80px',
  medium: '165px'
};
export const TILE_MAX_CHAR_COUNT = {
  small: 10,
  medium: 45
};